import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthState } from 'src/app/states/auth.state';
import { UserService } from 'src/app/services/user.service';
import { PushService } from 'src/app/services/push.service';
import { AbTestService } from 'src/app/services/ab-test.service';

@Component({
  selector: 'app-global-banner',
  templateUrl: './global-banner.component.html',
  styleUrls: ['./global-banner.component.scss']
})
export class GlobalBannerComponent implements OnInit, OnDestroy {
  user: any;
  public static events = {
    hide: 'global-banner:hide',
    show: 'global-banner:show'
  };

  private _hide: boolean = true;
  @Input() set inline(value: boolean) {
    if (value)
      this._hide = false;
  }

  abTestKey = 'global-banner';
  constructor(public sharedService: SharedService, public userService: UserService, public pushService: PushService) {
    if (sharedService.isBrowser) {
      AuthState.user$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(user => {
          this.user = user;
          this.load();
        });
    }
    this.banner = 'seeker-resume';

    this.sharedService.navigationEnd$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (!this.inline)
          this._hide = sharedService.getRouteData('hideBanner');
      });
  }

  banner: string;
  ngOnInit() { }

  async load() {
    if (this.user?.IsReadyToWork || this.user?.Seeker?.IsAcceptable) {
      if (!(this.user?.Seeker?.PromoteUntilDays > 0))
        this.banner = 'vanguard-seeker';
      else if (!this.user.IsReadyToWork)
        this.banner = 'ready-to-work';
      else delete this.banner;// = 'push-activator';
    }
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get show(): boolean {
    if (this._hide)
      return false;
    var hide = localStorage.getItem('global-banner-hide-' + this.banner);
    return !hide;
  }

  hide() {
    localStorage.setItem('global-banner-hide-' + this.banner, 'true');
  }
}
